import { useState } from 'react';
import { useAudio } from '../../contexts/AudioContext';
import { IoPlay, IoPause } from 'react-icons/io5';
import './PlayPauseButton.css'; // Import the CSS file

// This component is a button that plays or pauses a clip
// If a clip is provided, the button will play or pause that clip
// If no clip is provided, the button will play/pause the currently playing clip or the 
// next clip in the queue
export function PlayPauseButton({ clip, size = "40px", color = "#D9D9D9", isPlaybackBarButton = false }) {
    const { playClip, pauseClip, resumeClip, playNextClip, isPlaying, currentlyPlayingClip, queue, autoqueue } = useAudio();

    // Determine if the button should be disabled
    const isDisabled = !clip && !currentlyPlayingClip && queue.length <= 0 && autoqueue.length <= 0;
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async (event) => {
        event.stopPropagation(); // Prevent event from propagating to parent elements

        if (isDisabled) return; // Early return if button is disabled
        setIsLoading(true); // Set loading state to true
    
        const targetClip = clip ? clip : currentlyPlayingClip;
    
        try {
            if (!targetClip && (queue.length > 0 || autoqueue.length > 0)) {
                await playNextClip(); // Await asynchronous function if needed
            } else if (targetClip?.id !== currentlyPlayingClip?.id) {
                await playClip(targetClip); // Await asynchronous function if needed
            } else if (isPlaying) {
                await pauseClip(); // Await asynchronous function if needed
            } else {
                await resumeClip(); // Await asynchronous function if needed
            }
        } catch (error) {
            console.error('Error handling audio clip action:', error);
        } finally {
            setIsLoading(false); // Ensure loading state is set to false after operations complete
        }
    };
    
    const renderIcon = () => {
        const targetClip = clip ? clip : currentlyPlayingClip;
        if (isLoading) {
            return <div className="loader" />;
        }
        else if (!targetClip && queue.length > 0) {
            return <IoPlay color={color} size={size} />;
        } else if (targetClip?.id !== currentlyPlayingClip?.id) {
            return <IoPlay color={color} size={size} />;
        } else if (isPlaying) {
            return <IoPause color={color} size={size} />;
        } else {
            return <IoPlay color={color} size={size} />;
        }
    };

    return (
        <button 
            onClick={handleClick} 
            className={`${isPlaybackBarButton ? 'playbackPlayPauseButton' : 'playPauseButton'} ${isDisabled ? 'disabled' : ''}`} 
            disabled={isDisabled}
        >
            {renderIcon()}
        </button>
    );
}
